import React from 'react';
import '../../styles/c_HomeTraiteur.css';
import { useHomeData } from '../../hooks/useHomeData';

function HomeTraiteur() {
    const { data } = useHomeData();
    const traiteurData = data?.traiteur;

    if (!traiteurData?.title) {
        return <div className="loadingFiller"></div>;
    }

    return (
        <>
            <div id='homeTraiteurWrapper'>
                <img
                    src="/home/bg/slateBackgroung.svg"
                    alt=""
                    className="homeTraiteurBgOverlay"
                    aria-hidden="true"
                    loading="lazy"
                />
                <div className="homeTraiteurContent">
                    <h2 className='homeTraiteurTitle'><a href={traiteurData.button.href} target="_blank" rel="noreferrer">{traiteurData.title}</a></h2>
                    <p className='homeTraiteurSubtitle'>{traiteurData.subtitle}</p>
                    <p className='homeTraiteurDescription'>{traiteurData.description}</p>
                    <p className='homeTraiteurCallout'>{traiteurData.callout}</p>
                    <a className='homeTraiteurBtn' href={traiteurData.button.href} target="_blank" rel="noreferrer">{traiteurData.button.text}</a>
                </div>
                <div className="homeTraiteurGallery">
                    {traiteurData.gallery && traiteurData.gallery.map((image, index) => (
                        <div key={index} className="homeTraiteurGalleryItem">
                            <img src={image.path} alt={image.alt} loading='lazy' decoding='async' />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default HomeTraiteur;
